import React, { Children, useEffect, useRef, useState } from "react";
import style from "./MoreButton.module.css";

const MoreButton = ({
  icon,
  children,
  profileImg,
  width,
  imgWidth,
  imgHeight,
  top,
  right,
  className,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  const handleShowMenu = () => {
    setShowMenu(!showMenu);
  };
  const handleDocumentClick = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setShowMenu(false);
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <div className={`${style["parent"]} ${className}`} ref={menuRef}>
      <img
        alt="more"
        src={icon}
        className={profileImg ? style[profileImg] : style["more-img"]}
        style={{ width: imgWidth, height: imgHeight }}
        onClick={handleShowMenu}
      />
      {showMenu && (
        <div
          className={style["menu-container"]}
          style={{ width: width, top: top, right: right }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default MoreButton;
